export default "__VITE_ASSET__SeQrhfAb__"